<template>
  <div>
    <Main
      :height="height"
      :loading="loading"
      :tableData="tableData"
      :type="type"
      ref="tableMain"
    >
      <Header ref="tableHeader" slot="header" @query="getData" />
    </Main>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { Main, Header },
  props: {
    height: { type: Number, default: 300 },
    changeOrderCode: String,
    type: { type: String, default: 'radio' }
  },
  data() {
    return {
      usePage: true
    }
  },
  methods: {
    getData(form) {
      if (!this.changeOrderCode) return
      this.page.pageSize = 1000 //设置查询最大条数为1000
      const parmas = {
        changeOrderCode: this.changeOrderCode,
        ...form,
        ...this.page
      }
      this.loading = true
      this.$api.changeOrderBatchListApi(parmas).then((res) => {
        this.loading = false
        this.setData(res)
      })
    },
    choiceData() {
      return this.$refs.tableMain.choiceData()
    }
  }
}
</script>
